@if (sn?.isOpen$ | async) {
  <div class="sidenav z-fx-col" [@toggle]="sn?.position" (@toggle.done)="sn?.onAnimationDone($event)">
    <ng-container *ngTemplateOutlet="banner?.tr"></ng-container>
    @if (!noHeader) {
      <div class="sidenav-header z-fx z-fx-between-center z-fx-gap-16 zef-text-overflow-line z-fx-none">
        <div class="zef-text-h2 z-fx z-fx-start-center zef-text-ellipsis sidenav-title">
          <ng-container *ngTemplateOutlet="title?.tr"></ng-container>
        </div>
        <div class="sidenav-buttons z-fx z-fx-gap-4">
          <ng-container *ngTemplateOutlet="buttonSecondary?.tr"></ng-container>
          <ng-container *ngTemplateOutlet="buttonPrimary?.tr"></ng-container>
          @if (menu?.menu) {
            <button mat-icon-button color="secondary" [matMenuTriggerFor]="menu?.menu">
              <mat-icon>more</mat-icon>
            </button>
          }

          @if (showFullscreenToggle()) {
            <button
              mat-icon-button
              class="zef-transparent-button"
              matTooltip="Fullscreen"
              i18n-matTooltip
              (click)="fullscreen.set(!fullscreen())"
            >
              <mat-icon>fullscreen</mat-icon>
            </button>
          }

          <button
            mat-icon-button
            color="secondary"
            [inlineDialogTriggerFor]="discardDialog?.dialog || confirmMenu"
            [inlineDialogDisabled]="!confirmClose"
            (click)="trigger.inlineDialogDisabled && closeSidenav()"
            #trigger="inlineDialogTrigger"
          >
            <mat-icon>close</mat-icon>
          </button>
          <zef-inline-dialog (confirm)="closeSidenav()" #confirmMenu>
            <ng-container *dialogTitle i18n>Confirm close?</ng-container>
            <ng-container *dialogContent i18n>This will discard all your unsaved changes.</ng-container>
            <ng-container *dialogAction i18n>Discard changes</ng-container>
          </zef-inline-dialog>
        </div>
      </div>
      @if (loading) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      }
    }
    @if (withScroll) {
      <div class="zef-scroll-y" cdkScrollable>
        <ng-container *ngTemplateOutlet="content?.tr"></ng-container>
      </div>
    }
    @if (!withScroll) {
      <ng-template [ngTemplateOutlet]="content?.tr"></ng-template>
    }
  </div>
}
